module.exports = __webpack_public_path__ + "img/img-23.7bb353fe.png";